import { useMenuSection, useSeparator } from 'react-aria';
import MenuItem from '../MenuItem/MenuItem';
import styles from './MenuSection.module.scss';

const MenuSection = ({ section, state, onAction }) => {
    const { itemProps, headingProps, groupProps } = useMenuSection({
        heading: section.rendered,
        'aria-label': section['aria-label']
    });

    const { separatorProps } = useSeparator({
        elementType: 'li'
    });

    // If the section is not the first, add a separator element.
    // The heading is rendered inside an <li> element, which contains
    // a <ul> with the child items.
    return (
        <>
            {section.key !== state.collection.getFirstKey() &&
                (
                    <li
                        {...separatorProps}
                        className={styles.separator}
                    >
                        <hr className="govuk-section-break govuk-section-break--visible"/>
                    </li>
                )}
            <li
                {...itemProps}
                className={styles.section}
            >
                {section.rendered &&
                    (
                        <span
                            {...headingProps}
                            className={['govuk-caption-m', styles.heading].join(' ')}
                        >
                            {section.rendered}
                        </span>
                    )}
                <ul
                    {...groupProps}
                    style={{
                        padding: 0,
                        listStyle: 'none'
                    }}
                >
                    {[...section.childNodes].map((node) => (
                        <MenuItem
                            key={node.key}
                            item={node}
                            state={state}
                            onAction={onAction}
                        />
                    ))}
                </ul>
            </li>
        </>
    );
};

export default MenuSection;
